import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';

import { registerAd } from 'ducks/ads';
import { isSmallViewPort } from 'utils/viewports';

import style from './style.scss';

export class Banner extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    adUnitLevel3: PropTypes.string.isRequired,
    reset: PropTypes.bool.isRequired,
    registerAd: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.config = {};
  }

  getConfig() {
    const { id, adUnitLevel3 } = this.props;
    const pos = isSmallViewPort() ? 'wide-m1' : 'wide1';
    const adUnitLevel1 = isSmallViewPort() ? 'whatcar.m' : 'whatcar';
    const adUnit = ['8527', adUnitLevel1, 'valuation', adUnitLevel3];
    // You'll see non-standard ad sizes being defined here e.g. 320x51
    // This is due to the way Ad Ops target their ads and not a "mistake"
    const sizes = isSmallViewPort()
      ? [[320, 51], [320, 50]]
      : [[992, 115], [970, 251], [970, 250], [728, 91], [728, 90]];

    this.config = {
      id,
      adUnit,
      targeting: {
        pos,
        n_sec3: adUnitLevel3
      },
      sizes
      // We really should use size mappings but can't due to having to enforce oversized ads for tablet devices.
      // This is an example of how to use `sizeMap` in replacement of `sizes` and make use of GPTs `defineSizeMapping`
      // responsive ad slots in the ad-manager.
      // sizeMap: [
      //   {
      //     breakpoint: [990, 0],
      //     sizes: [[970, 250], [720, 90]]
      //   },
      //   {
      //     breakpoint: [768, 0],
      //     sizes: [[720, 90], [320, 50]]
      //   },
      //   {
      //     breakpoint: [320, 0],
      //     sizes: [[320, 50], [1, 1]]
      //   }
      // ]
    };

    return this.config;
  }

  componentDidUpdate() {
    const { registerAd, reset } = this.props;
    const config = this.getConfig();

    if (!reset) {
      registerAd(config);
    }
  }

  componentDidMount() {
    const { registerAd } = this.props;
    const config = this.getConfig();

    registerAd(config);
  }

  render() {
    const { id, reset } = this.props;

    return (
      <React.Fragment>
        {reset ? null : (
          <div id={id} className={classNames(style.ad, style.banner)} />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  reset: state.ads.reset
});

const mapDispatchToProps = {
  registerAd
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Banner);



// WEBPACK FOOTER //
// ./src/components/Ads/Banner.js